<template>
  <div>
    <label class="item-name"><i class="required" v-show="component.properties.required">*</i>{{initComponent.name}}</label>
    <div class="component-content">
      <el-input placeholder="自动生成无需填写" disabled/>
    </div>
  </div>
</template>

<script>
import { componentMixin } from '../mixins'
export default {
  name: 'rc-coding',
  props: [ 'initComponent' ],
  mixins: [ componentMixin ],
  data () {
    return {
      component: this.initComponent
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/form/components/coding/rc-coding.vue